import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Wind, FolderKanban, Users, ShoppingCart, LogOut, MessageSquare, ChevronDown, User, Settings, History, ClipboardList, Heart } from 'lucide-react';
import { useState } from 'react';
import { UserProfileModal } from './userProfileModal';
import '../styles/admin.css';
import API_BASE_URL from '../config';

export function NavbarDashbord() {
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const loggedUser = localStorage.getItem('user');
    const userObj = loggedUser ? JSON.parse(loggedUser) : { name: 'Admin', email: 'admin@gmail.com' };

    const handleLogout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('firebase_token');
        navigate('/login');
    };

    return (
        <div className="admin-sidebar">
            <div className="admin-profile-section-wrapper">
                <button 
                    className={`admin-profile-header-btn ${dropdownOpen ? 'active' : ''}`}
                    onClick={() => setDropdownOpen(true)}
                    title={userObj.name}
                >
                    <div className="admin-avatar">
                        <img 
                            src={userObj.profilePic 
                                ? userObj.profilePic.replace('http://localhost:8000', API_BASE_URL.replace('/api', '')) 
                                : "/admin-avatar.jpg"
                            } 
                            alt="Admin" 
                            onError={(e) => e.target.src = `https://ui-avatars.com/api/?name=${userObj.name}&background=700000&color=fff`} 
                        />
                    </div>
                    <div className="admin-user-info">
                        <h3 className="admin-name">{userObj.name}</h3>
                        <p className="admin-email">{userObj.email}</p>
                    </div>
                    <ChevronDown size={14} className={`chevron ${dropdownOpen ? 'rotate' : ''}`} />
                </button>

                <UserProfileModal 
                    isOpen={dropdownOpen} 
                    onClose={() => setDropdownOpen(false)} 
                    hideAdminLink={true}
                />
            </div>
            
            <nav className="admin-nav-links">
                <NavLink to="/dashbordPage" title="Dashboard" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
                    <LayoutDashboard size={18} />
                    <span>Dashboard</span>
                </NavLink>
                
                <NavLink to="/pageClimatisseurs" title="Climatiseurs" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
                    <Wind size={18} />
                    <span>Climatiseurs</span>
                </NavLink>
                
                <NavLink to="/pageProjets" title="Projets" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
                    <FolderKanban size={18} />
                    <span>Projets</span>
                </NavLink>
                
                <NavLink to="/pageComptes" title="Comptes" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
                    <Users size={18} />
                    <span>Comptes</span>
                </NavLink>
                
                <NavLink to="/pageCommandes" title="Commandes" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
                    <ShoppingCart size={18} />
                    <span>Commandes</span>
                </NavLink>

                <NavLink to="/pageCommentaires" title="Commentaires" className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
                    <MessageSquare size={18} />
                    <span>Commentaires</span>
                </NavLink>
            </nav>

            <div className="admin-sidebar-footer">
                <NavLink to="/" title="Retour à l'accueil" className="admin-footer-btn home-btn">
                    <LogOut size={16} style={{ transform: 'rotate(180deg)' }} />
                    <span>Retour à l'accueil</span>
                </NavLink>
                <button 
                    onClick={handleLogout}
                    title="Se déconnecter"
                    className="admin-footer-btn logout-btn"
                >
                    <LogOut size={16} />
                    <span>Se déconnecter</span>
                </button>
            </div>
        </div>
    );
}